import { RouteRecordRaw } from "vue-router";
const PricingDashboardPage = () => import("@/pages/pricing/partner/PricingDashboard.vue");
const PricingEditQuote = () => import("@/pages/pricing/partner/PricingQuoteBuilder.vue");
const PricingPage = () => import("@/pages/pricing/partner/PricingPage.vue");

const routes: RouteRecordRaw = {
  name: "pricing",
  path: "/pricing/",
  props: true,
  component: PricingPage,
  meta: {
    authenticated: true,
    permissions: ["pricing_pricing_dashboard"],
    breadcrumbs: [
      { label: "Pricing" },
      { label: "Dashboard", to: "pricingDashboard", on: ["pricingDashboard", "pricingEditQuote", "pricingNewQuote"] },
      { label: "Edit Pricing Request", to: "pricingEditQuote", on: ["pricingEditQuote"] },
      { label: "New Pricing Request", to: "pricingNewQuote", on: ["pricingNewQuote"] },
    ],
  },
  children: [
    {
      path: ":customerId",
      redirect: { name: "pricingDashboard" },
    },
    {
      name: "pricingDashboard",
      path: ":customerId/dashboard",
      component: PricingDashboardPage,
      props: true,
      meta: {
        title: `Pricing Dashboard`,
      },
    },
    {
      name: "pricingNewQuote",
      path: ":customerId/quote/new",
      component: PricingEditQuote,
      props: true,
      meta: {
        title: `New Pricing Request`,
      },
    },
    {
      name: "pricingEditQuote",
      path: ":customerId/quote/:quoteId",
      component: PricingEditQuote,
      props: true,
      meta: {
        title: `Edit Pricing Request`,
      },
    },
  ],
};

export default routes;
